export default __webpack_public_path__ + "static/team-image-7-4565ce748df8df8e854c31f7c5fa898b.png";